import axios from "../utils/axios";
import { config } from "../constants";

const BASE = `${config.url.TAPS_URL}/api/taps/custom_taps_vendor_configs`;

export const listVendorConfigs = async () => {
  const response = await axios.get(BASE);
  return response.data;
};

export const getVendorConfig = async (id) => {
  const response = await axios.get(`${BASE}/${id}`);
  return response.data;
};

export const createVendorConfig = async (data) => {
  const response = await axios.post(BASE, data);
  return response.data;
};

export const updateVendorConfig = async (id, data) => {
  const response = await axios.put(`${BASE}/${id}`, data);
  return response.data;
};

export const testVendorQuery = async (vendor_name, query, customer) => {
  const response = await axios.post(`${BASE}/test_query`, {
    vendor_name,
    query,
    customer,
  });
  return response.data;
};

export const describeTable = async (table_name, customer, query) => {
  const payload = { table_name, customer };
  if (query) payload.query = query;
  const response = await axios.post(`${BASE}/describe_table`, payload);
  return response.data;
};

export const previewHardDelete = async (data) => {
  const response = await axios.post(`${BASE}/preview_hard_delete`, data);
  return response.data;
};
